const heroSwiper = new Swiper(".mateHero", {
  loop: true,
  pagination: { el: ".swiper-pagination", clickable: true },
  parallax: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: { delay: 4000, disableOnInteraction: false },
  speed: 1200,
});
